let resizeTimeout: ReturnType<typeof setTimeout>

function updateTitlesForMobile() {
  const isMobile = window.innerWidth <= 768

  const titleEls = document.querySelectorAll('.js-product-title')

  if (titleEls && titleEls.length) {
    titleEls.forEach((titleEl) => {
      const original = titleEl.getAttribute('data-original-title')

      if (!original) {
        titleEl.setAttribute('data-original-title', titleEl.innerHTML)
      }

      if (isMobile) {
        if (titleEl.innerHTML.includes('mm') && !titleEl.innerHTML.includes('<br>')) {
          titleEl.innerHTML = titleEl.innerHTML.replace(/mm/g, 'mm<br>')
        }
      } else {
        if (original) {
          titleEl.innerHTML = original
        }
      }
    })
  }
}

window.addEventListener('DOMContentLoaded', function () {
  clearTimeout(resizeTimeout)
  resizeTimeout = setTimeout(updateTitlesForMobile, 300)
})
window.addEventListener('resize', function () {
  clearTimeout(resizeTimeout)
  resizeTimeout = setTimeout(updateTitlesForMobile, 150)
})
